import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import { SettingsProfil } from './profile';
import { SettingsSecurity } from './securite';
import { SettingsPaiement } from './paiement';
import { SettingsUsers } from './users';

export const Settings = ({user, isLoading}) => {
    return (
        <Switch>
            <Route exact path="/partner/settings">
                <SettingsProfil user={user} isLoading={isLoading} />
            </Route>
            <Route path="/partner/settings/securite" >
                <SettingsSecurity user={user} isLoading={isLoading} />
            </Route>
            <Route path="/partner/settings/paiement" component={SettingsPaiement} />
            <Route path="/partner/settings/users" component={SettingsUsers} />

            <Route render={() => {
                return <Redirect exact to="/partner/settings" />
            }} />
        </Switch>
    )
};